export const GRID_COLS = 18;
export const GRID_ROWS = 10;
export const TILE_PX = 64;
export const MAX_BLOCKS = 180;

export type PlacedBlock = {
  id: string; // block catalog id
  x: number; // tile
  y: number;
  layer: number;
};

export type LayoutValidation =
  | { ok: true }
  | { ok: false; reason: string };

export function validateLayout(
  layout: PlacedBlock[],
  ownedBlockIds: ReadonlySet<string> | readonly string[],
): LayoutValidation {
  if (!Array.isArray(layout)) return { ok: false, reason: 'not_array' };
  if (layout.length > MAX_BLOCKS) return { ok: false, reason: 'too_many' };

  const owned =
    ownedBlockIds instanceof Set
      ? ownedBlockIds
      : new Set(ownedBlockIds);

  const occupancy = new Set<string>();
  const usage = new Map<string, number>();

  for (const b of layout) {
    if (!b || typeof b.id !== 'string') return { ok: false, reason: 'bad_entry' };
    if (!Number.isInteger(b.x) || !Number.isInteger(b.y) || !Number.isInteger(b.layer)) {
      return { ok: false, reason: 'bad_coords' };
    }
    if (b.x < 0 || b.x >= GRID_COLS || b.y < 0 || b.y >= GRID_ROWS) {
      return { ok: false, reason: 'oob' };
    }
    if (!owned.has(b.id)) return { ok: false, reason: 'not_owned' };
    const key = `${b.x},${b.y},${b.layer}`;
    if (occupancy.has(key)) return { ok: false, reason: 'overlap' };
    occupancy.add(key);
    usage.set(b.id, (usage.get(b.id) ?? 0) + 1);
  }

  // owned list may contain duplicates for multi-qty; count available
  if (Array.isArray(ownedBlockIds)) {
    const available = new Map<string, number>();
    for (const id of ownedBlockIds) {
      available.set(id, (available.get(id) ?? 0) + 1);
    }
    for (const [id, n] of usage) {
      if ((available.get(id) ?? 0) < n) return { ok: false, reason: 'qty' };
    }
  }

  return { ok: true };
}
